// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__headerContainer___kZKTe {
  background-color: white;
  border-radius: 5px;
  padding: 12px 15px;
  width: 91%;
  margin: 0 0 20px 40px;
  position: relative;
}

.styles__subnumberTag___guGKy {
  display: inline-block;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  color: white;
  font-weight: bold;
  padding: 6px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 14px;
}

.styles__headerContent___G8gkr {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.styles__headerInfo___r9PM1 {
  flex: 1;
}

.styles__headerTitle___Rp4EX {
  font-size: 28px;
  font-weight: bold;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  margin: 0 0 2px 0;
  line-height: 1.2;
}

.styles__headerSubtitle___AubvD {
  font-size: 14px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  line-height: 1.2;
}

.styles__balanceContainer___i6gTI {
  text-align: right;
}

.styles__balanceLabel___PxO1H {
  font-size: 13px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
  margin-bottom: 2px;
}

.styles__balanceAmount___pKl7P {
  font-size: 24px;
  font-weight: bolder;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]};
  line-height: 1.2;
}


.styles__headerSection___b9d2B {
  flex: 0 0 70%;
}

.styles__notesSection___ZvBOu {
  flex: 0 0 28%;
  border-radius: 5px;

  align-self: flex-start;
}

.styles__section___RDt2p {
}

.styles__warning___yjnhV {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]};
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  font-size: 90%;
}

.styles__buttonSecondary___actCS {
}

.styles__fullWidth___ZuXJ_ {
  width: 100%;
}

.styles__contentContainer___OGj4J {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0;
  max-width: none;
  padding: 20px 0;
  height: 100%;
  width: 100%;
}

.styles__sectionNoMargin___L54Cl {
}

.styles__sectionTitle___oA0lu {
}

.styles__buttons___RAP43 {
  align-items: center;

  display: flex;
  justify-content: flex-end;
}

.styles__collapseRef___NE7Gd {
}

.styles__collapseRef___NE7Gd[data-active='true'] .styles__collapseIcon___lajG9 {
      transform: rotate(180deg);
    }

.styles__titleSection___OeyaT {
  position: relative;
}

.styles__titleSection___OeyaT:last-child {
    margin-bottom: 20px;
  }

.styles__titleSection___OeyaT .styles__name___AKxMe {
    transition: all 0.25s;
  }

.styles__titleSection___OeyaT .styles__noName___H8c1w {
    margin-top: 2px;
  }

.styles__title___ks6zJ {
  flex: 1;
}

.styles__docsWrapper___MibVm {
  background: white;
  border-radius: 0 0 3px 3px;
  padding: 14px;
}

.styles__cardMarginBot___kAb4t {
}

.styles__formRow___w4lTL {
  display: flex;
  gap: 15px;
  width: 100%;
}

.styles__formSection___Foycz {
  flex: 1;
  min-width: 0;
}

.styles__row___B6axp {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  transform: translateY(-10px);
  width: 100%;
}

.styles__logEntry___aPVSD {
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.styles__logEntry___aPVSD:last-child {
  border-bottom: none;
}

.styles__logDate___MZIzX {
  font-size: 14px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__logValue___cuqAl {
  font-size: 14px;
  font-weight: 500;
}
.styles__taxesLogTable___tFhcG,
.styles__appraisalLogTable___y5xsf,
.styles__inspectionLogTable___d97hO {
  margin-top: 15px;
  border-radius: 4px;
  padding: 12px;
}

.styles__taxesLogTable___tFhcG h6,
.styles__appraisalLogTable___y5xsf h6,
.styles__inspectionLogTable___d97hO h6 {
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 8px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
}

.styles__logEntry___aPVSD {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.styles__logEntryRow___wpD5g {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  padding-left: 14px;
}

.styles__logCompany___IhzEC {
  font-size: 14px;
  flex: 1;
  margin: 0 15px;
  text-align: center;
}
.styles__formSection___Foycz .styles__formRow___w4lTL {
  margin-bottom: 0;
}

.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker__input-container {
  width: 100%;
}

.react-datepicker__input-container input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  border-radius: 4px;
  font-size: 14px;
}

.react-datepicker__calendar-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
}

.styles__docsWrapper___MibVm > div:not(:last-child) {
  margin-bottom: 16px;
}

.styles__formRow___w4lTL {
  margin-bottom: 16px;
}

select {
  padding: 8px 12px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  background-color: white;
}

.styles__separator___MSCiH {
  height: 1px;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  margin: 20px 0;
  width: 100%;
}

.styles__container___m2wAf {
  padding: 10px;
}

.styles__dashboard___W1seQ {
  width: 100%;
  padding-bottom: 24px;
}

.styles__header___ernVc {
  margin-bottom: 16px;
}

.styles__idBadge___I8lCm {
  display: inline-block;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  color: white;
  padding: 5px 5px;
  border-radius: 4px;
}

.styles__idBadge___I8lCm span {
  font-weight: bold;
  font-size: 16px;
}

.styles__accountName___Tn2fT {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 18px;
  font-weight: 300;
  margin-top: 8px;
}

.styles__balanceSection___FcKAD {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.styles__mainBalance___Li7U9 {
  text-align: left;
}

.styles__subBalance___m3cLg {
  text-align: right;
}

.styles__mainBalance___Li7U9 .styles__balanceLabel___PxO1H {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
}

.styles__subBalance___m3cLg .styles__balanceLabel___PxO1H {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-weight: light;
}

.styles__balanceAmount___pKl7P {
  font-size: 28px;
  font-weight: bold;
}

.styles__mainBalance___Li7U9 .styles__balanceAmount___pKl7P {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
}

.styles__subBalance___m3cLg .styles__balanceAmount___pKl7P {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-weight: bold;
}

.styles__divider___maMyd {
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]};
  margin: 8px 0;
}

.styles__subaccountSection___laztY {
  padding-top: 6px;
}

.styles__combinedSection___xrJY2 {
  margin-bottom: 8px;
}

.styles__subaccountHeader___ckFLS {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 4px;
}

.styles__subaccountInfo___xHfni {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
  margin: 0;
}

.styles__status___HpP6j {
  display: flex;
  align-items: center;
}

.styles__statusIndicator___iROtR {
  width: 9px;
  height: 9px;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  border-radius: 50%;
  margin-right: 5px;
  flex-shrink: 0;
}

.styles__statusText___fnY09 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  font-size: 16px;
  line-height: 1.2;
  margin: 0;
}

.styles__subaccountDates___jnk1F {
  display: flex;
  justify-content: space-between;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  font-size: 12px;
}

.styles__infoRow___IiMzY {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 5px 0;
}

.styles__infoLabel___yj22d,
.styles__infoValue___eIWbU {
  font-size: 14px;
  margin-right: 8px;
  font-weight: bold;
}

.styles__checkmark___eB6kb {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
}

.styles__largeInputField___xxn7C input {
  height: 100px; /* Increase height */
  min-width: 300px; /* Set minimum width */
}

.styles__statusIndicator___iROtR {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 5px;
  flex-shrink: 0;
}

.styles__statusText___fnY09 {
  font-size: 16px;
  line-height: 1.2;
  margin: 0;
}

.styles__statusActive___Wzg1N .styles__statusIndicator___iROtR {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  }

.styles__statusActive___Wzg1N .styles__statusText___fnY09 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  }

.styles__statusClosed___WXLtg .styles__statusIndicator___iROtR {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__statusClosed___WXLtg .styles__statusText___fnY09 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }

.styles__statusPending___uUIav .styles__statusIndicator___iROtR {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
  }

.styles__statusPending___uUIav .styles__statusText___fnY09 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  }
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Subaccounts/EditSubaccount/styles.css"],"names":[],"mappings":"AAIA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8DAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mDAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mDAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mDAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oDAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;;EAElB,sBAAsB;AACxB;;AAEA;AAEA;;AAEA;EACE,8DAA+B;EAC/B,8DAA0B;EAC1B,mDAAmB;EAEnB,cAAc;AAChB;;AAEA;AAEA;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,mBAAmB;;EAEnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;AAQA;;AAJI;MACE,yBAAyB;IAC3B;;AAIJ;EAEE,kBAAkB;AAapB;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,OAAO;AACT;;AAEA;EAEE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mDAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;EAGE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mDAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+DAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mDAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+DAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,+DAA6B;EAC7B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8DAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mDAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mDAAW;AACb;;AAEA;EACE,mDAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mDAAW;AACb;;AAEA;EACE,mDAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mEAAiC;EACjC,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8DAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mDAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mDAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mDAAc;AAChB;;AAEA;EACE,aAAa,EAAE,oBAAoB;EACnC,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAGE;IACE,8DAAyB;EAC3B;;AAEA;IACE,mDAAc;EAChB;;AAIA;IACE,8DAAuB;EACzB;;AAEA;IACE,mDAAY;EACd;;AAIA;IACE,8DAA0B;EAC5B;;AAEA;IACE,mDAAmB;EACrB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: 'styles/colors.css';\n@value gtYellow, gtYellowDark, gtYellowLight, gtBlue, gtGreen, gtRed, gtGray, gtGrayDark, textLight, text, textDark, borderColor from colors;\n\n.headerContainer {\n  background-color: white;\n  border-radius: 5px;\n  padding: 12px 15px;\n  width: 91%;\n  margin: 0 0 20px 40px;\n  position: relative;\n}\n\n.subnumberTag {\n  display: inline-block;\n  background-color: gtBlue;\n  color: white;\n  font-weight: bold;\n  padding: 6px 10px;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.headerContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.headerInfo {\n  flex: 1;\n}\n\n.headerTitle {\n  font-size: 28px;\n  font-weight: bold;\n  color: gtBlue;\n  margin: 0 0 2px 0;\n  line-height: 1.2;\n}\n\n.headerSubtitle {\n  font-size: 14px;\n  color: gtBlue;\n  line-height: 1.2;\n}\n\n.balanceContainer {\n  text-align: right;\n}\n\n.balanceLabel {\n  font-size: 13px;\n  color: text;\n  margin-bottom: 2px;\n}\n\n.balanceAmount {\n  font-size: 24px;\n  font-weight: bolder;\n  color: textDark;\n  line-height: 1.2;\n}\n\n\n.headerSection {\n  flex: 0 0 70%;\n}\n\n.notesSection {\n  flex: 0 0 28%;\n  border-radius: 5px;\n\n  align-self: flex-start;\n}\n\n.section {\n  composes: section from helpers;\n}\n\n.warning {\n  background-color: gtYellowLight;\n  border: 1px solid gtYellow;\n  color: gtYellowDark;\n  composes: section from helpers;\n  font-size: 90%;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.contentContainer {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n  margin: 0;\n  max-width: none;\n  padding: 20px 0;\n  height: 100%;\n  width: 100%;\n}\n\n.sectionNoMargin {\n  composes: sectionNoMargin from helpers;\n}\n\n.sectionTitle {\n  composes: sectionTitle from helpers;\n}\n\n.buttons {\n  align-items: center;\n\n  display: flex;\n  justify-content: flex-end;\n}\n\n.collapseRef {\n  composes: collapseRef from helpers;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.titleSection {\n  composes: sectionTitle row from helpers;\n  position: relative;\n\n  &:last-child {\n    margin-bottom: 20px;\n  }\n\n  .name {\n    transition: all 0.25s;\n  }\n\n  .noName {\n    margin-top: 2px;\n  }\n}\n\n.title {\n  flex: 1;\n}\n\n.docsWrapper {\n  composes: flexColumn from helpers;\n  background: white;\n  border-radius: 0 0 3px 3px;\n  padding: 14px;\n}\n\n.cardMarginBot {\n  composes: cardMarginBot from helpers;\n}\n\n.formRow {\n  display: flex;\n  gap: 15px;\n  width: 100%;\n}\n\n.formSection {\n  flex: 1;\n  min-width: 0;\n}\n\n.row {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  transform: translateY(-10px);\n  width: 100%;\n}\n\n.logEntry {\n  padding: 8px 0;\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n}\n\n.logEntry:last-child {\n  border-bottom: none;\n}\n\n.logDate {\n  font-size: 14px;\n  color: textLight;\n}\n\n.logValue {\n  font-size: 14px;\n  font-weight: 500;\n}\n.taxesLogTable,\n.appraisalLogTable,\n.inspectionLogTable {\n  margin-top: 15px;\n  border-radius: 4px;\n  padding: 12px;\n}\n\n.taxesLogTable h6,\n.appraisalLogTable h6,\n.inspectionLogTable h6 {\n  font-size: 14px;\n  font-weight: normal;\n  margin-bottom: 8px;\n  color: textLight;\n}\n\n.logEntry {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n}\n\n.logEntryRow {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  padding-left: 14px;\n}\n\n.logCompany {\n  font-size: 14px;\n  flex: 1;\n  margin: 0 15px;\n  text-align: center;\n}\n.formSection .formRow {\n  margin-bottom: 0;\n}\n\n:global(.react-datepicker-wrapper) {\n  width: 100%;\n}\n\n:global(.react-datepicker__input-container) {\n  width: 100%;\n}\n\n:global(.react-datepicker__input-container input) {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid borderColor;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n:global(.react-datepicker__calendar-icon) {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: gtBlue;\n}\n\n.docsWrapper > div:not(:last-child) {\n  margin-bottom: 16px;\n}\n\n.formRow {\n  margin-bottom: 16px;\n}\n\nselect {\n  padding: 8px 12px;\n  border: 1px solid borderColor;\n  border-radius: 4px;\n  font-size: 14px;\n  width: 100%;\n  background-color: white;\n}\n\n.separator {\n  height: 1px;\n  background-color: borderColor;\n  margin: 20px 0;\n  width: 100%;\n}\n\n.container {\n  padding: 10px;\n}\n\n.dashboard {\n  width: 100%;\n  padding-bottom: 24px;\n}\n\n.header {\n  margin-bottom: 16px;\n}\n\n.idBadge {\n  display: inline-block;\n  background-color: textLight;\n  color: white;\n  padding: 5px 5px;\n  border-radius: 4px;\n}\n\n.idBadge span {\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.accountName {\n  color: textLight;\n  font-size: 18px;\n  font-weight: 300;\n  margin-top: 8px;\n}\n\n.balanceSection {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.mainBalance {\n  text-align: left;\n}\n\n.subBalance {\n  text-align: right;\n}\n\n.mainBalance .balanceLabel {\n  color: text;\n}\n\n.subBalance .balanceLabel {\n  color: textLight;\n  font-weight: light;\n}\n\n.balanceAmount {\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.mainBalance .balanceAmount {\n  color: text;\n}\n\n.subBalance .balanceAmount {\n  color: textLight;\n  font-weight: bold;\n}\n\n.divider {\n  border-top: 1px solid borderColor;\n  margin: 8px 0;\n}\n\n.subaccountSection {\n  padding-top: 6px;\n}\n\n.combinedSection {\n  margin-bottom: 8px;\n}\n\n.subaccountHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  padding-bottom: 4px;\n}\n\n.subaccountInfo {\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.status {\n  display: flex;\n  align-items: center;\n}\n\n.statusIndicator {\n  width: 9px;\n  height: 9px;\n  background-color: gtGreen;\n  border-radius: 50%;\n  margin-right: 5px;\n  flex-shrink: 0;\n}\n\n.statusText {\n  color: gtGreen;\n  font-size: 16px;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.subaccountDates {\n  display: flex;\n  justify-content: space-between;\n  color: textLight;\n  font-size: 12px;\n}\n\n.infoRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 5px 0;\n}\n\n.infoLabel,\n.infoValue {\n  font-size: 14px;\n  margin-right: 8px;\n  font-weight: bold;\n}\n\n.checkmark {\n  color: gtGreen;\n}\n\n.largeInputField input {\n  height: 100px; /* Increase height */\n  min-width: 300px; /* Set minimum width */\n}\n\n.statusIndicator {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  margin-right: 5px;\n  flex-shrink: 0;\n}\n\n.statusText {\n  font-size: 16px;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.statusActive {\n  .statusIndicator {\n    background-color: gtGreen;\n  }\n\n  .statusText {\n    color: gtGreen;\n  }\n}\n\n.statusClosed {\n  .statusIndicator {\n    background-color: gtRed;\n  }\n\n  .statusText {\n    color: gtRed;\n  }\n}\n\n.statusPending {\n  .statusIndicator {\n    background-color: gtYellow;\n  }\n\n  .statusText {\n    color: gtYellowDark;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `'styles/colors.css'`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"headerContainer": `styles__headerContainer___kZKTe`,
	"subnumberTag": `styles__subnumberTag___guGKy`,
	"headerContent": `styles__headerContent___G8gkr`,
	"headerInfo": `styles__headerInfo___r9PM1`,
	"headerTitle": `styles__headerTitle___Rp4EX`,
	"headerSubtitle": `styles__headerSubtitle___AubvD`,
	"balanceContainer": `styles__balanceContainer___i6gTI`,
	"balanceLabel": `styles__balanceLabel___PxO1H`,
	"balanceAmount": `styles__balanceAmount___pKl7P`,
	"headerSection": `styles__headerSection___b9d2B`,
	"notesSection": `styles__notesSection___ZvBOu`,
	"section": `styles__section___RDt2p ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"warning": `styles__warning___yjnhV ${___CSS_LOADER_ICSS_IMPORT_1___.locals["section"]}`,
	"buttonSecondary": `styles__buttonSecondary___actCS ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"fullWidth": `styles__fullWidth___ZuXJ_`,
	"contentContainer": `styles__contentContainer___OGj4J`,
	"sectionNoMargin": `styles__sectionNoMargin___L54Cl ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionNoMargin"]}`,
	"sectionTitle": `styles__sectionTitle___oA0lu ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]}`,
	"buttons": `styles__buttons___RAP43`,
	"collapseRef": `styles__collapseRef___NE7Gd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["collapseRef"]}`,
	"collapseIcon": `styles__collapseIcon___lajG9`,
	"titleSection": `styles__titleSection___OeyaT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionTitle"]} ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"name": `styles__name___AKxMe`,
	"noName": `styles__noName___H8c1w`,
	"title": `styles__title___ks6zJ`,
	"docsWrapper": `styles__docsWrapper___MibVm ${___CSS_LOADER_ICSS_IMPORT_1___.locals["flexColumn"]}`,
	"cardMarginBot": `styles__cardMarginBot___kAb4t ${___CSS_LOADER_ICSS_IMPORT_1___.locals["cardMarginBot"]}`,
	"formRow": `styles__formRow___w4lTL`,
	"formSection": `styles__formSection___Foycz`,
	"row": `styles__row___B6axp`,
	"logEntry": `styles__logEntry___aPVSD`,
	"logDate": `styles__logDate___MZIzX`,
	"logValue": `styles__logValue___cuqAl`,
	"taxesLogTable": `styles__taxesLogTable___tFhcG`,
	"appraisalLogTable": `styles__appraisalLogTable___y5xsf`,
	"inspectionLogTable": `styles__inspectionLogTable___d97hO`,
	"logEntryRow": `styles__logEntryRow___wpD5g`,
	"logCompany": `styles__logCompany___IhzEC`,
	"separator": `styles__separator___MSCiH`,
	"container": `styles__container___m2wAf`,
	"dashboard": `styles__dashboard___W1seQ`,
	"header": `styles__header___ernVc`,
	"idBadge": `styles__idBadge___I8lCm`,
	"accountName": `styles__accountName___Tn2fT`,
	"balanceSection": `styles__balanceSection___FcKAD`,
	"mainBalance": `styles__mainBalance___Li7U9`,
	"subBalance": `styles__subBalance___m3cLg`,
	"divider": `styles__divider___maMyd`,
	"subaccountSection": `styles__subaccountSection___laztY`,
	"combinedSection": `styles__combinedSection___xrJY2`,
	"subaccountHeader": `styles__subaccountHeader___ckFLS`,
	"subaccountInfo": `styles__subaccountInfo___xHfni`,
	"status": `styles__status___HpP6j`,
	"statusIndicator": `styles__statusIndicator___iROtR`,
	"statusText": `styles__statusText___fnY09`,
	"subaccountDates": `styles__subaccountDates___jnk1F`,
	"infoRow": `styles__infoRow___IiMzY`,
	"infoLabel": `styles__infoLabel___yj22d`,
	"infoValue": `styles__infoValue___eIWbU`,
	"checkmark": `styles__checkmark___eB6kb`,
	"largeInputField": `styles__largeInputField___xxn7C`,
	"statusActive": `styles__statusActive___Wzg1N`,
	"statusClosed": `styles__statusClosed___WXLtg`,
	"statusPending": `styles__statusPending___uUIav`
};
export default ___CSS_LOADER_EXPORT___;
